import React from "react";

const FlowDex = () => {
  return (
    <>
      <div className="flowbox-container">

        {/* ==================== COMPANY 1: RESIDENT INTERFACE ==================== */}
        <div className="company-section-header">
          <h3>Resident Interface / Hunter Warfield</h3>
          <span className="company-badge">Aug 2025 – Present</span>
        </div>

        {/* Card 1: Resident Interface Overview */}
        <div className="flowbox-top">
          <div className="imgHolder">
            <img className="myImg" src="/img/exp/resident.png" alt="Resident Interface Unified Platform" />
          </div>
          <div className="contentHolder">
            <div className="title">
              Resident Interface / Hunter Warfield
            </div>
            <div>
              <div className="subtitle">
                Full Stack Engineer <span>(Aug 2025 – Present)</span>
              </div>
              <div className="content" style={{ fontSize: "0.88rem", color: "#666", marginBottom: "8px" }}>
                • Full-Time Employee under Resident Interface <em>(Feb 2026 – Present)</em><br />
                • Contract based work with Hunter Warfield <em>(Aug 2025 – Feb 2026)</em>
              </div>
              <div className="content">
                Contributed to the development of Resident Interface's upcoming <strong>Unified Platform</strong> — an end-to-end delinquency management system covering legal notices, rent litigation, writ of eviction processing, and final debt collection.
              </div>
            </div>
            <div>
              <span className="highlight-badge">Delinquency Management & Litigation Workflows</span>
            </div>
          </div>
        </div>

        {/* Card 2: Resident Interface Highlights */}
        <div className="flowbox-left">
          <div className="imgHolder">
            <img className="myImg" src="/img/exp/up.webp" alt="Workflow Automation" />
          </div>
          <div className="contentHolder">
            <div className="title">Systems & Workflow Automation</div>
            <div className="subtitle">
              Eviction Lifecycle & Document Template Management
            </div>
            <div className="content">
              • <strong>Automated Workflow Pipeline:</strong> Implemented real-time task routing and execution across eviction case lifecycles for internal staff, notaries, attorneys, and system background workers.
            </div>
            <div className="content">
              • <strong>Nutrient PDF Editor Integration:</strong> Streamlined document template management to automate generation of legal notices, court dockets, hearing documents, and legal filings.
            </div>
            <div>
              <span className="highlight-badge">Real-Time Routing & Automated Legal Generation</span>
            </div>
          </div>
        </div>


        {/* ==================== COMPANY 2: TATA CONSULTANCY SERVICES ==================== */}
        <div className="company-section-header">
          <h3>Tata Consultancy Services (TCS)</h3>
          <span className="company-badge">Jun 2021 – Jul 2025</span>
        </div>

        {/* Card 3: TCS Overview */}
        <div className="flowbox-right">
          <div className="imgHolder">
            <img className="myImg" src="/img/exp/tcs.webp" alt="TCS Work Experience" />
          </div>
          <div className="contentHolder">
            <div className="title">Systems Engineer @ TCS</div>
            <div>
              <div className="subtitle">
                Full Stack Web Developer <span>(4 Years)</span>
              </div>
              <div className="content">
                4 years of industry experience at{" "}
                <a href="https://www.tcs.com/" target="_blank" rel="noreferrer">
                  Tata Consultancy Services (TCS)
                </a>{" "}
                delivering high-performance web applications across monolithic, microservices, and event-driven architectures.
              </div>
            </div>
            <div className="content">
              TCS is a global leader in IT services and consulting. During my tenure, I had the privilege of working with two major international clients: <strong>Condé Nast</strong> and <strong>College Advisor</strong>.
            </div>
          </div>
        </div>

        {/* Card 4: Clients in TCS */}
        <div className="flowbox-left">
          <div className="imgHolder">
            <img className="myImg" src="/img/exp/client.png" alt="Clients in TCS" />
          </div>
          <div className="contentHolder">
            <div className="title">Clients & Key Portfolios</div>
            <div className="content">
              Extensive experience collaborating with international stakeholders, delivering enterprise-scale features tailored to client growth goals:
            </div>
            <div>
              <div className="subtitle">
                1. College Advisor <span>(Feb 2024 – Jul 2025)</span>
              </div>
              <div className="content">
                Ed-tech platform helping over 5,000+ students achieve college admissions through algorithmic advisor matching and personalized digital tools.
              </div>
            </div>
            <div>
              <div className="subtitle">
                2. Condé Nast <span>(Jun 2021 – Jan 2024)</span>
              </div>
              <div className="content">
                Global media player reaching 72M+ consumers across iconic brands: <em>Vogue, GQ, Architectural Digest, CNTraveller, Vanity Fair</em>, etc.
              </div>
            </div>
          </div>
        </div>

        {/* Card 5: Algorithmic Features & Impact */}
        <div className="flowbox-right">
          <div className="imgHolder">
            <img className="myImg" src="/img/exp/frt.webp" alt="Algorithmic Matching" />
          </div>
          <div className="contentHolder">
            <div className="title">Algorithmic Features & Business Impact</div>
            <div>
              <div className="subtitle">Smart Match Algorithm & Advisor Filters</div>
              <div className="content">
                • <strong>Smart Match Engine:</strong> Developed a multi-criteria scoring algorithm matching prospective students to advisors via domain interests, target institutions, geography, and time zones — <strong>scaling premium student conversions from 68% to 92%</strong>.
              </div>
              <div className="content">
                • <strong>Smart Advisor Filter Tool:</strong> Built interactive pitch-prep tools for sales teams to evaluate matching profiles prior to discovery calls.
              </div>
            </div>
            <div>
              <span className="highlight-badge">Conversion Impact: <strong className="highlight-pill">68% → 92% Conversion Scale</strong></span>
            </div>
          </div>
        </div>

        {/* Card 6: Fintech & Payments */}
        <div className="flowbox-left">
          <div className="imgHolder">
            <img className="myImg" src="/img/exp/back1.webp" alt="Fintech & Subscriptions" />
          </div>
          <div className="contentHolder">
            <div className="title">Fintech, Subscriptions & Monetization</div>
            <div className="content">
              • <strong>Payment Gateways:</strong> Integrated and maintained transactional payment solutions across <strong>Stripe, Juspay, Razorpay, and PayPal</strong>, standardizing checkout workflows and error handling.
            </div>
            <div className="content">
              • <strong>Recurring Billing Pipelines:</strong> Automated subscription and renewal pipelines for Condé Nast India publications with dashboard controls to switch between one-time & auto-renewals.
            </div>
            <div className="content">
              • <strong>Digital Invoicing:</strong> Powered custom checkout pages with Stripe and automated transactional email receipts for College Advisor.
            </div>
            <div>
              <span className="highlight-badge">Gateways: Stripe • Juspay • Razorpay • PayPal</span>
            </div>
          </div>
        </div>

        {/* Card 7: Data Engineering & Infrastructure */}
        <div className="flowbox-right">
          <div className="imgHolder">
            <img className="myImg" src="/img/exp/data.webp" alt="Infrastructure & Data" />
          </div>
          <div className="contentHolder">
            <div className="title">Data Engineering & Growth Integrations</div>
            <div className="content">
              • <strong>Meta/Facebook Conversion API:</strong> Integrated server-side attribution data across media sites for targeted ad campaigns.
            </div>
            <div className="content">
              • <strong>Google MakeStories Integration:</strong> Streamlined one-click publishing of interactive Google Web Stories with WordPress pipelines.
            </div>
            <div className="content">
              • <strong>Zero-Downtime Server Migration:</strong> Migrated legacy server and PHP WordPress environments with <strong>under 5 minutes of downtime</strong> for high-traffic media properties.
            </div>
            <div>
              <span className="highlight-badge">High Availability: <strong className="highlight-pill">&lt; 5 Min Migration Downtime</strong></span>
            </div>
          </div>
        </div>

      </div>
    </>
  );
};

export default FlowDex;
